import { Text } from '@/components/ui/text';

type DisclaimerTextProps = {
  children: string;
};

export function DisclaimerText({ children }: DisclaimerTextProps) {
  return <Text className="text-sm leading-[1.4] text-typography-900">{children}</Text>;
}
